"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordExpired = void 0;
var react_1 = __importDefault(require("react"));
var SplitPage_1 = require("@app/components/layout/SplitPage");
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var PasswordExpired = function () { return (react_1.default.createElement(SplitPage_1.SplitPage, { title: "Password Expired" },
    react_1.default.createElement(ContainerPanel_1.ContainerPanel, { title: "Your password has expired", className: "expired-password" },
        react_1.default.createElement("p", { className: "has-text-centered" }, "Your password has expired."),
        react_1.default.createElement("p", { className: "has-text-centered" }, "An email from Blast@hasbro.com has been sent with instructions to update your password.")))); };
exports.PasswordExpired = PasswordExpired;
